import React from 'react';

export const Check: React.FC<{ color?: string; size?: number }> = ({ color = '#6C6F88', size = 32 }) => (
	<svg height={size ? size : 32} width={size ? size : 32} viewBox={`0 0 32 32`} fill='none'>
		<path d='M8 16.8667L13.0909 22L24 11' stroke={color} strokeWidth='4' strokeLinecap='round' strokeLinejoin='round' />
	</svg>
);

export default Check;
